import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'src/app/micro-services/user/models/user';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { HelperService } from 'src/app/services/helper.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-list-client-selectable',
  templateUrl: './list-client-selectable.component.html',
  styleUrls: ['./list-client-selectable.component.scss'],
})
export class ListClientSelectableComponent implements OnInit {

  @Input() isOneValueSelectable: boolean = false;
  @Input() selectedUsers : User[] = [];
  @Input() onlyActifUser : boolean = false;
  
  @Output() users = new EventEmitter<User[]>();

  users$: Observable<User[]>;
  save$: Observable<User[]>;

  search : string;

  constructor(
    private userService: UserService,
    private apiProvider: ApiProviderService,
    private modalCtrl: ModalController,
    private helper: HelperService
    ) {
  }

  ngOnInit() {
    const coach = this.userService.getUser();
    const coachId = coach.id;
    if(this.onlyActifUser){
      this.users$ = this.save$ = this.apiProvider.getUsersByCoach(coachId).pipe(
        map(user => user.filter(u => u.isActive !== false) )
      );
    }else{
      this.users$ = this.save$ = this.apiProvider.getUsersByCoach(coachId);
    }

  }

  selectedUser(user: User){
    if(this.isOneValueSelectable)
    {
      this.selectedUsers = [JSON.parse(JSON.stringify(user))];
    }else{
      var test = this.helper.checkIfAlreadyExist(this.selectedUsers, user);
      if(!test)
      {
        this.selectedUsers.unshift(JSON.parse(JSON.stringify(user)));
      }
    }
  }

  confirm(){
    this.users.emit(this.selectedUsers);
    return this.modalCtrl.dismiss(this.selectedUsers, 'confirm');
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  deleteUser(index : number){
    this.selectedUsers.splice(index,1);
  }

  userSearch(event){
    if(event){
      this.users$ = this.save$.pipe(
        map(users => users.filter(
          user => user.userName.toLowerCase().includes(event.toLowerCase()) || user.firstName?.toLowerCase().includes(event.toLowerCase()) || user.name?.toLowerCase().includes(event.toLowerCase()) ||user.email.toLowerCase().includes(event.toLowerCase()) 
          ))
       );
    }else{
      this.users$ = this.save$;
    }
  }

}
